import React, { createContext, ReactNode, useContext } from 'react'
import { useActivation } from 'apps/fleet-planner/hooks/useActivation'

export interface IActivateState extends ReturnType<typeof useActivation> {}

/**
 * Init the context
 */
export const activateDefaultState: IActivateState = {
  isLoading: false,
  mobileApp: false,
} as IActivateState

// Creates the context object that we'll pass into components
export const ActivationContext = createContext<IActivateState>(activateDefaultState)

/**
 * Provide default Provider state component to wrap around app
 */
export const ActivationProvider = ({ children }: { children: ReactNode }): JSX.Element => {
  const activateState = useActivation()
  return <ActivationContext.Provider value={activateState}>{children}</ActivationContext.Provider>
}

export const useActivationContext = () => useContext(ActivationContext)
